<template>
    <div class="hero-body">
        <div class="container has-text-centered">
            <div class="column is-4 is-offset-4">
                <h3 class="title has-text-black">Autentificare</h3>
                <hr class="login-hr" />
                <div class="box">
                    <div class="field">
                        <div class="control">
                            <b-input
                                type="password"
                                placeholder="Parola"
                                @keydown.enter.prevent="login"
                                v-model="password"
                            ></b-input>
                        </div>
                    </div>
                    <b-button :loading="isLoading" type="is-block is-info is-fullwidth" @click="login">Login</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as toast from '@/utils/toast';

export default {
    data: () => ({
        password: '',
        isLoading: false,
    }),
    methods: {
        async login() {
            if (this.password == null || this.password === '') {
                return toast.error('Parola necompletata', 5000, 'is-top');
            }
            this.isLoading = true;
            try {
                await this.$store.dispatch('app/Login', {
                    password: this.password.trim(),
                });
                this.$router.push({
                    path: '/admin',
                });
            } catch (err) {
                return false;
            } finally {
                this.isLoading = false;
            }
        },
    },
    created() {
        document.documentElement.style.backgroundColor = '#f8f8f8';
    },
};
</script>

<style></style>
